export interface ProfessionClassModel {
  id: string;
  name: string;
}
